import { create } from 'zustand';

interface RavanStore {
  isOpen: boolean;
  openRavan: () => void;
  closeRavan: () => void;
  toggleRavan: () => void;
}

export const useRavanStore = create<RavanStore>((set) => ({
  isOpen: false,
  openRavan: () => set({ isOpen: true }),
  closeRavan: () => set({ isOpen: false }),
  toggleRavan: () => set((state) => ({ isOpen: !state.isOpen })),
}));
